import { apiGet } from './client'

export interface RunSummary {
  id: string
  plan_id: string
  plan_version_id: string | null
  mode: string
  status: string
  started_at: string | null
  ended_at: string | null
  backtest_start: string | null
  backtest_end: string | null
  metrics: Record<string, unknown> | null
}

export interface RunListResponse {
  count: number
  runs: RunSummary[]
}

export interface Outcome {
  id: string
  kind: string
  instrument: string
  opened_at: string | null
  closed_at: string | null
  realized_pnl: number | null
  metadata: Record<string, unknown> | null
}

export interface RunDetail {
  run: RunSummary & {
    initial_capital: number | null
    error_message: string | null
  }
  outcomes: Outcome[]
}

export const listRuns = (params: { plan_id?: string; mode?: string; limit?: number } = {}) =>
  apiGet<RunListResponse>('/runs', { params })

export const getRun = (runId: string, includeOutcomes = true) =>
  apiGet<RunDetail>(`/runs/${runId}`, { params: { include_outcomes: includeOutcomes } })
